<template>
  <div>
    <!-- Your other content... -->
    <button class="back-button"  @click="goBack">Назад</button>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'BackButton',
  setup() {
    const router = useRouter()
    function goBack() {
      router.go(-1);
    }

    return { goBack };
  }
};
</script>


<style scoped>
/* Styles for the back button */
.back-button {
  background-color: #fff;
  color: #333;
  border: 1px solid #ccc;
  padding: 2px 15px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.back-button:hover {
  background-color: #e0e0e0;
}

.back-button:focus {
  outline: none;
}

</style>
